<script setup lang="ts">
import { ref, inject, watch, type Ref } from "vue";
import { useAnalyticManager } from "@magnit/analytic-events";
import VModal from "@magnit/core/src/components/VModal/VModal.vue";
import VButton from "@magnit/core/src/components/VButton/VButton.vue";
import VEmpty from "@magnit/core/src/containers/VEmpty/VEmpty.vue";
import EighteenPlusIcon from "../assets/base-illustration-112-eighteen-plus.svg";
import { provideKeys } from "@magnit/unit-catalog/src/unit-catalog.vars";
import type {
  IModalAdultEmits,
  IModalAdultProps,
} from "@magnit/unit-catalog/src/unit-catalog.types";

const props = withDefaults(defineProps<IModalAdultProps>(), {
  approveLabel: "Да, есть",
  rejectLabel: "Нет, закрыть",
  analyticsPayload: () => ({}),
});

const emit = defineEmits<IModalAdultEmits>();
const { send: nativeSend } = useAnalyticManager();
const send = props.analyticsSender || nativeSend;
const isDialogOpened = inject<Ref<boolean>>(
  provideKeys.isDialogOpened,
  ref(false),
);

const updateApprove = inject<(v: boolean) => void>(
  provideKeys.updateApprove,
  () => {},
);

const onApprove = () => {
  updateApprove(true);
  send("ModalAdult:Click:Yes", props.analyticsPayload);
  emit("approve");
};
const onReject = () => {
  updateApprove(false);
  send("ModalAdult:Click:No", props.analyticsPayload);
  emit("reject");
};

watch(
  isDialogOpened,
  (v) => v && send("ModalAdult:View", props.analyticsPayload),
);
</script>

<template>
  <VModal
    id="unit-modal-adult"
    wrapper-class="unit-modal-adult"
    :closable="false"
    :open="isDialogOpened"
    :type="{ xs: 'bottom-sheet', m: 'modal' }"
    :active="isDialogOpened"
  >
    <VEmpty
      :icon="EighteenPlusIcon"
      title="Вам есть 18 лет?"
      description="На этой странице есть товары, которые можно смотреть только с 18 лет"
    />
    <template #footer>
      <div class="unit-modal-adult__buttons">
        <VButton full-width @click="onApprove()"> {{ approveLabel }} </VButton>
        <VButton theme="secondary" full-width @click="onReject()">
          {{ rejectLabel }}
        </VButton>
      </div>
    </template>
  </VModal>
</template>

<style scoped lang="postcss">
.unit-modal-adult {
  &__buttons {
    display: flex;
    flex-direction: column;
    gap: var(--pl-unit-x4);

    @media (--pl-viewport-from-m) {
      gap: 10px;
    }
  }
}
</style>
